import { render, staticRenderFns } from "./RawLinkInfo.vue?vue&type=template&id=065f35ae&scoped=true"
import script from "./RawLinkInfo.vue?vue&type=script&lang=js"
export * from "./RawLinkInfo.vue?vue&type=script&lang=js"
import style0 from "./RawLinkInfo.vue?vue&type=style&index=0&id=065f35ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "065f35ae",
  null
  
)

export default component.exports